import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';   
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from 'react-toastify'
import { DomainProvider } from './context/DomainContext';
import { ThemeProvider } from './context/ThemeContext';
import './theme/hotToastTheme';

if (!sessionStorage.getItem("API_BASE_URL")) {
  //sessionStorage.setItem("API_BASE_URL", "https://dev-adminapi.greenyourbills.com");
}

// Basic examples
// toast("Default message")                         // gray info style
// toast.success("Profile saved successfully!")
// toast.error("Failed to upload file")
// toast.info("New message from Ajay")
// toast.warning("Low battery — 12%")
// toast.loading("Uploading...")                    // returns a toastId

// Update / dismiss a specific toast (great for promises)
// const toastId = toast.loading("Processing...")

// setTimeout(() => {
//   toast.update(toastId, {
//     render: "Done!",
//     type: "success",
//     isLoading: false,
//     autoClose: 3000
//   })
// }, 2000)

// Promise helper — super clean for API calls
// const promise = () => new Promise((resolve) => setTimeout(resolve, 2000))

// toast.promise(
//   promise(),
//   {
//     pending: "Waiting for server...",
//     success: "Yay! Operation completed 👌",
//     error: "Oops! Something broke 😞"
//   }
// )

// Custom content (JSX, icons, actions)
// toast(
//   <div className="flex items-center gap-3">
//     <span className="text-xl">🚀</span>
//     <div>
//       <strong>Project deployed!</strong>
//       <p className="text-sm">Check it live now</p>
//     </div>
//   </div>,
//   { icon: false }  // hide default icon if you want
// )

// With action button
// toast("Item added to cart", {
//   action: {
//     label: "View Cart",
//     onClick: () => console.log("Go to cart")
//   }
// })

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
  <DomainProvider>
  <ThemeProvider>
    <App />
    <ToastContainer
      position="top-right"          // or "top-center", "bottom-right", etc.
      autoClose={5000}              // ms — false to disable auto-close
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"                 // "light" | "dark" | "colored"
      // transition={Bounce}        // optional: Slide, Zoom, Flip, Bounce
    />
    </ThemeProvider>
    </DomainProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
